import React, { Component } from "react";

import { fork } from "@formant/core/common/fork";
import { IEvent } from "@formant/core/model/IEvent";
import { isInterventionRequestType } from "@formant/core/model/isInterventionRequestType";

import { authStore, eventStore } from "../../../stores";
import { EventChip } from "../../common/EventChip";
import * as styles from "./index.scss";
import { LabelingRequestDetails } from "./LabelingRequestDetails";
import { SelectionRequestDetails } from "./SelectionRequestDetails";

export interface IInterventionRequestDetailsProps {
    event: IEvent;
    onRespond: () => void;
}

export class InterventionRequestDetails extends Component<IInterventionRequestDetailsProps> {
    public render() {
        const { event, onRespond } = this.props;

        if (event.type !== "intervention-request") {
            return;
        }

        if (
            !event.viewed &&
            authStore.hasRequiredAccess("events", "operator")
        ) {
            fork(eventStore.view({ id: event.id }));
        }

        return (
            <div className={styles["intervention-request-details"]}>
                <div className={styles.content}>
                    {isInterventionRequestType(event, "selection") && (
                        <SelectionRequestDetails
                            request={event}
                            onRespond={onRespond}
                        />
                    )}

                    {isInterventionRequestType(event, "labeling") && (
                        <LabelingRequestDetails
                            request={event}
                            onRespond={onRespond}
                        />
                    )}
                </div>
                <EventChip event={event} />
            </div>
        );
    }
}
